import React, { useCallback, useState } from 'react'


/**
 * Google Forms `?embedded=true` omits the theme header banner that you see on
 * the normal viewform URL. Put the same image as your form header in
 * `public/google-form-header.jpg` (or change HEADER_SRC) so it shows above the iframe.
 */
function Form() {
  

  return (
    <div className="flex min-h-[100dvh] w-full flex-col bg-[#DFF6ED]">
      {/* <img
        src={HEADER_SRC}
        alt=""
        aria-hidden
        onLoad={onHeaderLoad}
        onError={onHeaderError}
        className={
          headerVisible
            ? 'max-h-[280px] w-full shrink-0 object-cover object-center md:max-h-[320px]'
            : 'hidden h-0 w-0'
        }
        decoding="async"
      /> */}

      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLScmSrsQ7BrZpBQWN-FE-UGny5YXkpcBNyaQMZ_JNWetbPgm5g/viewform"
        title="Google Form"
        className="min-h-0 w-full flex-1 border-0 bg-[#DFF6ED]"
      />
    </div>
  )
}

export default Form
